module.exports = __webpack_public_path__ + "img/icon-trash.35681284.svg";